import React from 'react';
import { Typography } from '@mui/material';
import {
    HeaderContainer,
    EmployeeColumn,
    ShiftsColumn,
    StatusColumn
} from './PeopleTableHeader.styles';

const PeopleTableHeader = () => {
    return (
        <HeaderContainer>
            <EmployeeColumn>
                <Typography variant="h6GrayUppercase">All People</Typography>
            </EmployeeColumn>
            <ShiftsColumn>
                <Typography variant="h6GrayUppercase">Shifts</Typography>
            </ShiftsColumn>
            <StatusColumn>
                <Typography variant="h6GrayUppercase">Status</Typography>
            </StatusColumn>
        </HeaderContainer>
    );
};

export default PeopleTableHeader;
